import PrescriptionsPage from "./PrescriptionsPage";
export default PrescriptionsPage;
